import BackButton from "components/BackButton";
import React, { useState } from "react";
import InstituteOfChargeList from "./InstituteOfChargeList";
import InstituteOfChargeDetail from "./InstituteOfChargeDetail";
import { InvestigationFile } from "types";

type Props = {
  file: InvestigationFile;
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const InstituteOfChargeTab: React.FC<Props> = ({
  file,
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  const [pageType, setPageType] = useState<"list" | "detail">("list");
  const [selectedCaseId, setSelectedCaseId] = useState<string | number>("");

  return (
    <div className="space-y-6">
      {pageType === "list" ? (
        <InstituteOfChargeList
          file={file}
          crimeReferenceNumber={crimeReferenceNumber}
          incidentRegistrationNumber={incidentRegistrationNumber}
          setSelectedCaseId={setSelectedCaseId}
          setPageType={setPageType}
        />
      ) : (
        <div className="space-y-4">
          <BackButton onClick={() => setPageType("list")} />
          <InstituteOfChargeDetail caseId={selectedCaseId} />
        </div>
      )}
    </div>
  );
};

export default InstituteOfChargeTab;
